"use strict";

module.exports = function (column) {
    return !this.opts.descOrderColumns.includes(column);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tables-2/compiled/methods/initial-order-ascending.js
// module id = bgbN
// module chunks = 58